var map = {
	"./anxiang/icon_shakehands.png": "ObQO",
	"./default/icon_shakehands.png": "AgaX",
	"./huarong/icon_shakehands.png": "iB4G",
	"./master/icon_shakehands.png": "gT0U",
	"./shaodong/icon_shakehands.png": "fvYU",
	"./taoyuan/icon_shakehands.png": "nTVZ",
	"./yueyang/icon_shakehands.png": "A11r",
	"./zhuzhou/icon_shakehands.png": "tvek"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pr7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/icon_shakehands\.png$
// module id = pr7f
// module chunks = 1